var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pui-modal-dialog-form',{attrs:{"titleText":_vm.$t('action.userapp.reset2FASecretAction'),"modelName":_vm.modelName,"dialogName":_vm.reset2FASecretModal,"onOk":_vm.onOkReset2FASecretModal}},[_c('template',{slot:"message"},[_c('v-row',{attrs:{"dense":""}},[_vm._v(" "+_vm._s(_vm.$t('modal.userapp.reset2FASecretDesc'))+" ")])],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }